import React, { Fragment } from 'react';
var Loader = function Loader(props) {
  var styleInline = {
    width: props.width || '5rem'
  };
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "remotecare-admin-panel-loader",
    style: styleInline
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)));
};
export default Loader;